import { ReactElement } from "react";
import { useTooltip } from "../../../hooks/UseTooltip";
import { IComponent } from "../../../services/http/component/models/IComponent";
import ComponentItem from "./ComponentItem";

interface ComponentListProps
{
    components: IComponent[];
    className?: string;
    allowTooltips?: boolean;
    tooltipClass?: string;
    component?: IComponent;
}

const ComponentsList = (props: ComponentListProps): ReactElement => {

    const { setupTooltip, clearTooltip, Tooltip } = useTooltip();

    return (
    <>
        <div
            className={props.className}
            onMouseLeave={clearTooltip}
        >
            {props.components &&
                props.components.map(x => (
                    <div key={x.id}>
                        <ComponentItem
                            component={x}
                            setupTooltip={setupTooltip}
                            allowTooltips={!!props.allowTooltips}
                            tooltipClass={props.tooltipClass}
                        />
                    </div>
                ))}
            {props.component &&
                <div key={props.component.id}>
                            <ComponentItem
                                component={props.component}
                                setupTooltip={setupTooltip}
                                allowTooltips={!!props.allowTooltips}
                                tooltipClass={props.tooltipClass}
                                noLink={true}
                            />
                </div>
            }
            <Tooltip />
        </div>
    </>
)};

export default ComponentsList;
